import {
  RequestFormFragment,
  RequestFormType,
  RequestFormVisibility,
} from '../../../__generated__/graphql';

const EMPLOYEE_VISIBLE_FORM_VISIBILITIES: ReadonlyArray<RequestFormVisibility> =
  [RequestFormVisibility.HrEmployee, RequestFormVisibility.HrManagerEmployee];

const isFormVisibleToEmployee = (form: RequestFormFragment): boolean =>
  EMPLOYEE_VISIBLE_FORM_VISIBILITIES.includes(form.flair__Visibility__c);

// Groups OBJECT_DATA_CHANGE Request Forms by their data-change target object,
// dropping forms whose visibility hides them from the current employee.
// Forms are sorted by Id for stable ordering across renders. Empty groups
// (object types with no matching form) are not present in the map.
export const buildEditableFormsByObject = (
  forms: ReadonlyArray<RequestFormFragment>,
): Map<string, RequestFormFragment[]> => {
  const map = new Map<string, RequestFormFragment[]>();
  forms
    .filter(
      (form) =>
        form.flair__Request_Type__c === RequestFormType.ObjectDataChange &&
        !!form.flair__Data_Change_Object_Name__c &&
        isFormVisibleToEmployee(form),
    )
    .slice()
    .sort((a, b) => a.Id.localeCompare(b.Id))
    .forEach((form) => {
      const objectName = form.flair__Data_Change_Object_Name__c!;
      const existing = map.get(objectName);
      if (existing) {
        existing.push(form);
      } else {
        map.set(objectName, [form]);
      }
    });
  return map;
};
